<template>
  <RightDrawer :moreInfo="false" :width="920">
    <div v-if="host">
      <h6 class="text-uppercase grey--text">
        {{ $t('hausefulInvoices.host') }}
      </h6>
      <p>{{ host }}</p>
    </div>

    <div v-if="customer">
      <h6 class="text-uppercase grey--text">
        {{ $t('hausefulInvoices.customer') }}
      </h6>
      <p>{{ customer }}</p>
    </div>

    <div v-if="createdAt">
      <h6 class="text-uppercase grey--text">
        {{ $t('hausefulInvoices.createdAt') }}
      </h6>
      <p>{{ createdAt }}</p>
    </div>

    <div v-if="creator">
      <h6 class="text-uppercase grey--text">
        {{ $t('hausefulInvoices.creator') }}
      </h6>
      <p>{{ creator }}</p>
    </div>

    <div class="d-flex gap-1">
      <div v-if="hasSender">
        <h6 class="text-uppercase grey--text">
          {{ $t('hausefulInvoices.sender') }}
        </h6>
        <p>{{ receiverAndSenderType(invoice.sender) }}</p>
      </div>
      <div v-if="hasReceiver">
        <h6 class="text-uppercase grey--text">
          {{ $t('hausefulInvoices.receiver') }}
        </h6>
        <p>{{ receiverAndSenderType(invoice.receiver) }}</p>
      </div>
    </div>

    <div v-if="total">
      <h6 class="text-uppercase grey--text">
        {{ $t('hausefulInvoices.total') }}
      </h6>
      <p>{{ total }}</p>
    </div>

    <div v-if="comment">
      <h6 class="text-uppercase grey--text">
        {{ $t('hausefulInvoices.comment') }}
      </h6>
      <p>{{ comment }}</p>
    </div>

    <h3 class="mt-10 mb-5">
      {{ $t('hausefulInvoices.payments') }}
    </h3>

    <v-data-table
      :no-data-text="$t('table.noResults')"
      :headers="paymentHeaders"
      :items="payments"
      class="body-2"
      hide-default-footer
    >
      <template v-slot:item.code="{ item }">
        <a href="#">#{{ item.code }}</a>
      </template>
      <template v-slot:item.customer_cost="{ item }">
        <span class="red--text">{{ item.customer_cost }}</span>
      </template>
      <template v-slot:item.value="{ item }">
        <span class="green--text">{{ item.value }}</span>
      </template>
      <template v-slot:item.transaction="{ item }">
        <v-chip small>
          {{ item.transaction }}
          <CopyToClipboard :value="item.transaction" />
        </v-chip>
      </template>
    </v-data-table>
  </RightDrawer>
</template>

<script>
import RightDrawer from '@/components/app/RightDrawer'
import CopyToClipboard from '@/components/app/CopyToClipboard'

import { catalogDate, catalogMonetary } from '@/util/catalog'

export default {
  name: 'AdminInvoiceDetails',

  components: {
    RightDrawer,
    CopyToClipboard,
  },

  props: {
    invoice: {
      type: Object,
      required: false,
    },
  },

  computed: {
    host() {
      return this.invoice?.host?.name
    },

    customer() {
      return this.invoice?.real_estate?.name
    },

    creator() {
      return this.invoice?.created_by?.name
    },

    createdAt() {
      return this.invoice?.created_at && this.formatDate(this.invoice.created_at)
    },

    total() {
      return this.invoice?.total && this.formatMoney(this.invoice.total)
    },

    comment() {
      return this.invoice?.comment
    },

    payments() {
      return this.invoice?.payments_list ?? []
    },

    hasSender() {
      return this.invoice?.sender
    },

    hasReceiver() {
      return this.invoice?.receiver
    }
  },

  methods: {
    receiverAndSenderType(type) {
      if (!type) return '---'
      return this.$t(`hausefulInvoices.${type}`)
    },
  },

  data() {
    return {
      paymentHeaders: [],
      formatMoney: catalogMonetary,
      formatDate: catalogDate,
    }
  }
}
</script>
